import React, { useEffect, useState } from "react";

import { useInput } from "../../../shared/hooks/form-fields";
import { Textarea } from "../../form-inputs/inputs";

export const DialogRejectReason = ({ message, data, action }) => {
    const descInput = useInput("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (error && descInput.value) {
            setError(false);
        }
    }, [descInput.value]);

    const onReject = () => {
        if (!descInput.value) {
            setError("A reason must be provided in order to reject a task");

            return false;
        }

        action.remove();
        action.resolve({
            reject: true,
            reason: descInput.value,
        });
    };

    const onCancel = () => {
        action.remove();
        action.resolve({
            reject: false,
            reason: "",
        });
    };

    return (
        <div className={message ? "" : "txt-center"}>
            {message && (
                <>
                    <h3>{message}</h3>
                    <h4>Reason for reject:</h4>
                </>
            )}
            {!message && <h3>Reason for reject:</h3>}
            {error && <p className="txt-error">{error}</p>}
            <Textarea name="rejectReason" {...descInput.bind} required={true} />
            <div className="button-group -center">
                <button className="button -full" onClick={onCancel}>
                    Cancel
                </button>
                <button className="button -full -primary" onClick={onReject}>
                    Reject
                </button>
            </div>
        </div>
    );
};
